import Header from './components/header';
import Footer from './components/footer';
import './App.css';
import html2pdf from 'html2pdf.js';
import { useEffect, useRef, useState } from 'react';
import { renderToString } from 'react-dom/server';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

function App() {


    const [kitcode, setKitCode] = useState("");
    const handleSubmit = (e) => {
      e.preventDefault(); 
      console.log("Kit Code Submitted:", kitcode); 
      setloading(true);
      setReport(true);
      setGenerate(true);
      // handleDownloadPDF()
    };

  const [data, setdata] = useState([])
  const [newerr, setNewErr] = useState(false)
  const [loading, setloading] = useState(true)
  const [generate,setGenerate] = useState(false)
  const [report,setReport] = useState(false)

  const contentRef = useRef();
  // const contentRef2 = useRef();


  const getdata = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    const urlencoded = new URLSearchParams();
    // urlencoded.append("Kitcode", "SGDEMO");
    urlencoded.append("Kitcode", kitcode);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow"
    };
    fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getmicrobiomeresults", requestOptions)
    // fetch("http://localhost:1337/getmicrobiomeresults", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setdata(result)
        setloading(false)
      })
      .catch((error) => {console.error(error); setGenerate(false); setNewErr(true);
        setTimeout(() => {
          setNewErr(false)
          setReport(false)
          setKitCode("")
        }, 2000);
      });

  }


  useEffect(() => {
    // console.log("downloading")
    handleDownloadPDF()
  }, [data])

  useEffect(() => {
    getdata()
  }, [report])



  const AgeCalculator = ({ birthdate }) => {
    const calculateAge = (birthdate) => {
      const birthDate = new Date(birthdate);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      // Adjust age if the birthday hasn't occurred yet this year
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age;
    };

    return (
      <>
        {calculateAge(birthdate)}
      </>
    );
  };



  // const handleDownloadPDF = async () => {
  //   const content = await document.getElementById('ali'); // Replace with the ID of the content you want to export


  //   const opt = {
  //     margin: 0,
  //     filename: "YourGutMap - Microbiome result.pdf",
  //     image: { type: 'png', quality: 1 },
  //     html2canvas: { scale: 1 },
  //     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  //   };

  //   const seee = html2pdf().from(content).set(opt).outputPdf();



  //   seee.save("YourGutMap - Microbiome result .pdf")
  // };

  const handleDownloadPDF = async () => {
    const content = document.getElementById('ali'); // Target your content by ID
    
    const opt = {
      // margin: 10,  // Adjust margin as needed to fit content
      filename: `SpaceGut - Patient report ${kitcode}.pdf`,
      image: { type: 'jpeg', quality: 0.99 },  // JPEG with high quality for better compression
      html2canvas: { scale: 1 },               // Increase canvas scale for higher quality
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true, dpi: 150 }, // Lower dpi for reduced size
    };
    
    // console.log("I am ali samoo")
    html2pdf()
    .from(content)
    .set(opt)
    .save(`SpaceGut - Patient report ${kitcode}.pdf`);
    // console.log("I am saad")
    setGenerate(false)
    setKitCode("")
    setReport(false)
  };





  // const download = async () => {
  //   // Hide the button by adding the class
  //   // const button = document.getElementById('ali');
  //   // if (button) button.classList.add('hide-for-pdf');

  //   const pdf = new jsPDF();
  //   const pages = document.querySelectorAll('.page1');
  //   console.log(pages.length);

  //   for (let i = 0; i < pages.length; i++) {
  //     try {
  //       // Capture each page using html2canvas
  //       const canvas = await html2canvas(pages[i], { scale: 2 });
  //       const imgData = canvas.toDataURL('image/png');

  //       if (i > 0) {
  //         pdf.addPage();
  //       }

  //       // Get the page dimensions
  //       const pageWidth = pdf.internal.pageSize.getWidth();
  //       const pageHeight = pdf.internal.pageSize.getHeight();

  //       // Add the captured image to the PDF
  //       pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight);

  //     } catch (error) {
  //       console.error("Error capturing page", i, error);
  //     }
  //   }

  //   // Save the PDF
  //   pdf.save('test-report.pdf');
  //   console.log("done")

  //   // Show the button again by removing the class
  //   // if (button) button.classList.remove('hide-for-pdf');
  // }


const ageData = [
  "It appears that your microbiome is younger than you! The personalized nutrition plan we've put together for you, will help you keep your microbiome young longer!","It appears your microbiome reflects your actual age. However, with the personalized nutrition plan we’ve put together for you, you’ve begun your journey toward rejuvenating your microbiome and making it younger!","It appears your microbiome is aging faster than you. However, with the personalized nutrition plan we’ve put together for you, you’ve begun your journey toward rejuvenating your microbiome and improving your health!."
]
const diversityData = [
  "Excellent! While you have an excellent level of diversity, our personalized nutrition plan will help you maintain your diverse microbiome longer.","Moderately Good With Room For Improvement: While you have a decent level of diversity, our personalized nutrition plan will help you achieve an even more diverse microbiome.","Poor, With Need For Improvement: Although you have a pretty low level of diversity, our personalized nutrition plan will help you improve it and achieve a more diverse microbiome."
]

const getClass = (title) => {
  const flag = data["gut-scores"].find(item => item.title === title)?.flag;  // Safe access with optional chaining
    // console.log(flag);
    if (flag === "good") return    "number";  // Color for 'good'
    if (flag === "average") return "number1";  // Color for 'average'
    if (flag === "bad") return     "number1";  // Color for 'bad'

    return "";  // Default or empty if no match
}

const getPara = (type) => {
  if(type === "age"){
    const flag = data["microbiome-age-range"].find(item => item.name === "Your Microbiome Age")?.flag;
    if (flag === "good") return    ageData[0];
    if (flag === "average") return ageData[1];
    if (flag === "bad") return     ageData[2];
    return ""; // Default or empty if no match
  }
  if(type === "diversity"){
    const flag = data["microbiome-age-range"].find(item => item.name === "Your Microbiome Diversity")?.flag;
    if (flag === "good") return    diversityData[0];
    if (flag === "average") return diversityData[1];
    if (flag === "bad") return     diversityData[2];
    return ""; // Default or empty if no match
  }
}

  const getImageSrc = (type, title, add = "") => {
    // const flag = data[type][index].flag;
    const flag = data[type].find(item => item.title === title || item.name === title)?.flag;
    console.log(flag);
    if (flag === "good") return `page4/552${add}.png`;
    if (flag === "average") return `page4/551${add}.png`;
    if (flag === "bad") return `page4/55${add}.png`;
    return ""; // Default or empty if no match
  };
  const getColor = (type, title) => {
    // const flag = data[type]?.[index]?.flag;  // Safe access with optional chaining
    const flag = data[type].find(item => item.title === title || item.name === title)?.flag;
    // console.log(flag);
    if (flag === "good") return "#2496d3";  // Color for 'good'
    if (flag === "average") return "#f4bd55";  // Color for 'average'
    if (flag === "bad") return "#e3614f";  // Color for 'bad'

    return "";  // Default or empty if no match
  };
  const getIcon = (bacteria) => {
    const flag = data["gut-scores"].find(item => item.title === bacteria)?.flag;  // Safe access with optional chaining
    // console.log(flag);
    if (flag === "good") return "plus-icon";  // Color for 'good'
    if (flag === "average") return "rhombus-icon";  // Color for 'average'
    if (flag === "bad") return "x-icon";  // Color for 'bad'

    return "";  // Default or empty if no match
  }
  let BreadandCereals = 0

  let BreadandCereals2 = 0
  let Vegetablessss = 0
  let Vegetablessss2 = 0
  let Vegetablessss3 = 0


  let Fruitssss = 0
  let Fruitssss2 = 0
  let Fruitssss3 = 0

  let drinkssss = 0
  let drinkssss2 = 0

  let fish1 = 0
  let fish2 = 0

  let cheese1 = 0
  let cheese2 = 0

  let herbs = 0
  let herbs2 = 0
  return generate==true ? (
  <div className='App'>

    {/* {data.length === 0 ? (<>loading...</>) : (<> */}
    {loading ? (<div style={{display:"flex",marginTop:"100px",flexDirection:"column",alignItems:"center"}}>
      <img src="page1.png" alt="" width={200} />
      <h4>Your report is downloading, please wait!</h4>
      </div>) : (<>
      <div style={{display:"flex", justifyContent:"space-between", width:"210mm"}}>
        {/* <button className='downloadbuttonviewreport' style={{width:"40mm"}}  onClick={handleDownloadPDF}>Download</button>
        <button className='changeview' style={{width:"40mm"}} onClick={()=>{setGenerate(false); setKitCode("")}}>Get New Report</button> */}
      </div>
      <div className="App" ref={contentRef} id='ali' >
        {/* page 1 */}
        <div id="page1" className='page1'>
          <div className="page1img"  style={{margin:"0mm"}}>
            <img src="page1.png" alt="" />
          </div>
          <div className="text-box">
            <h1>PATIENT NAME: {data["pateint-info"].name}</h1>
            <h1>AGE:  <AgeCalculator birthdate={data["pateint-info"].date_of_birth} /> Years</h1>
            <h1>GENDER: {data["pateint-info"].gender}</h1>
            <h1>KIT CODE: {data["Kitinfo"].kit_code}</h1>
          </div>
        </div>


        {/* page 2 */}
        <div id="page2" className='page1'></div>


        {/* page 3*/}
        <div id="page3" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Microbiome Analysis Report</h2>
            <p>From birth, your microbiome is significantly impacted by the world around you. And while environmental factors and genetics certainly play a role, dietary changes and nutritional influences account for 50-60% of the factors that alter your microbiome. Ingesting foods that increase or decrease certain bacteria can end up wreaking havoc, resulting in imbalance and manifesting into dysfunction. Fortunately, we know how foods behave relative to microorganisms and because we've mapped your entire microbiome, we have the most personalized dietary recommendations within this report needed for you to achieve true balance within your microbiome and optimal overall health.</p>
            <h4>A healthy microbiome:</h4>
            <div className="text1">
              <div className="hexagon-small">
                <span className='page3icon'><img src="Page 3/plays.png" alt="" style={{ width: "70px", transform: 'rotate(0deg)' }} /></span>
              </div>
              <h4>plays an important role in maintaning the ideal weight</h4>
            </div>
            <div className="text2">
              <div className="hexagon-small">
                <span className='page3icon'><img style={{marginLeft:"100px", width: "70px", transform: 'rotate(0deg)' }} src="Page 3/maintains.png" alt="" /></span>
              </div>
              <h4 style={{marginLeft:"30px"}}>maintains a strong immune system</h4>
            </div>
            <div className="text1">
              <div className="hexagon-small">
                <img src='/Page 3/support1.png' width={"70px"} />
              </div>
              <h4>Supports the structure and funtion of the digestive system</h4>
            </div>
            <div className="text2">
              <div className="hexagon-small">
                <img src='/Page 3/promotes healthy, radiant skin .png' style={{marginLeft:"100px"}} width={"70px"} />
              </div>
              <h4 style={{marginLeft:"30px"}}>Promotes healthy, radiant skin</h4>
            </div>
            <div className="text1">

              <div className="hexagon-small">
                <img src='/Page 3/Supports the structure of the brain and the production and balance of the chemicals necessary mental health.png' width={"70px"} />
              </div>

              <h4>Supports the structure of the brain and rthe production and balance of the chemicals necessary mental health</h4>

            </div>
            <div className="text2">
              <div className="hexagon-small">
                <img src='/Page 3/Is vitally important for sleep quality.png' style={{marginLeft:"100px"}} width={"70px"} />
              </div>
              <h4 style={{marginLeft:"30px"}}>is vitally important for sleep quality </h4>
            </div>
            <div className="page3img">
              <img src="page3.png" alt="" />
            </div>
          </div>
          <Footer />
        </div>


        {/* page 4*/}
        <div id="page4" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>WELCOME TO YOUR MICROBIOME WORLD</h2>
            <p>Let's look at the dashboard of your microbiome world. Here you'll find your microbiome age, the level of bacterial diversity and gut scores for the 13 of the most clinically important areas of your body.</p>
            <p>Remember, while this information does not represent any type of diagnosis, we are
              offering you a detailed look into the level of balance, or imbalance, within your gut. And
              as a result of these scores have laid out a personalized nutrition guide to renew and
              balance your microbiome.</p>
            <div className="scorehead">
              <h4 style={{ color: getColor("microbiome-age-range", "Your Microbiome Age") }}>your microbiome age </h4>
              <div className="" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={getImageSrc("microbiome-age-range", "Your Microbiome Age")} style={{ margin: "0px", padding: "0px", width: "75px" }} alt="" />
                <h1 style={{ fontSize: "33px", fontWeight: "500", position: "absolute", color: getColor("microbiome-age-range", "Your Microbiome Age") }}>{data["microbiome-age-range"].find(item=>item.name === "Your Microbiome Age")?.score}</h1>
              </div>
              {/* <div className="hexagon-small-lightblue"><span className='hxasmalltext'><h1>{data["microbiome-age-range"][1].score}</h1></span></div> */}

              {/* <div className="hexagon-small-red"><span className='hxasmalltext'><h1>{data["microbiome-age-range"][0].score}</h1></span></div> */}
              <div className="" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={getImageSrc("microbiome-age-range", "Your Microbiome Diversity")} style={{ margin: "0px", padding: "0px", width: "75px" }} alt="" />
                <h1 style={{ fontSize: "33px", fontWeight: "500", position: "absolute", color: getColor("microbiome-age-range", "Your Microbiome Diversity") }}>{data["microbiome-age-range"].find(item=>item.name === "Your Microbiome Diversity")?.score}</h1>
              </div>
              <h4 style={{ color: getColor("microbiome-age-range", "Your Microbiome Diversity") }}>your microbiome diversity </h4>
            </div>

            <div className="scorediv">
              <h3 style={{ fontWeight: "500", marginTop: "13px", marginBottom: "0px", marginRight: "18px", textAlign: "center" }}>Gut Scores</h3>
              <div className="gutscore1">
                {/* <div className="plus-icon"><span className="number">{data["gut-scores"][6].score}</span></div> */}
                {/* <div className={"rhombus-icon"} ><span className="number" >{data["gut-scores"].find(item => item.title === "Metabolic Score")?.score}</span></div> */}
                <div className={getIcon("Metabolic Score")}><span className={getClass("Metabolic Score")}>{data["gut-scores"].find(item => item.title === "Metabolic Score")?.score}</span></div>
                <h4>Metabolic Score</h4>
                <img src="page4/Metabolic Score.png" style={{ width: "43px" }} alt="" />
                {/* <div className="hexagon-icon2">
                  <span className='p4icon'><img src="page4img/line1p4.png" alt="" /></span>
                  </div> */}
              </div>
              <div className="gutscore2">
                {/* <div className="hexagon-icon">
                  <span className='p4icon'><img src="page4img/line2p4.png" alt="" /></span>
                  </div> */}
                <img src="page4/Carbohydrate Metabolism.png" style={{ width: "43px" }} alt="" />
                {/* <img src="page4/Carbohydrate Metabolism.png" style={{ width: "47px" }} alt="" /> */}
                <h4>Carbohydrate Metabolism</h4>
                <div className={getIcon("Carbohydrate Metabolism")}><span className={getClass("Carbohydrate Metabolism")}>{data["gut-scores"].find(item => item.title === "Carbohydrate Metabolism")?.score}</span></div>
              </div>
              <div className="gutscore1">
                <div className={getIcon("Protein Metabolism")}><span className={getClass("Protein Metabolism")}>{data["gut-scores"].find(item => item.title === "Protein Metabolism")?.score}</span></div>
                <h4>Protein Metabolism</h4>
                <img src="page4/Protein Metabolism.png" style={{ width: "43px" }} alt="" />
                {/* <div className="hexagon-icon2">
                  <span className='p4icon'><img src="page4img/line3p4.png" alt="" /></span>
                  </div> */}
              </div>
              <div className="gutscore2">
                <img src="page4/Fat Metabolism.png" style={{ width: "43px" }} alt="" />
                {/* <div className="hexagon-icon">
                  <span className='p4icon'><img src="page4img/line4p4.png" alt="" /></span>
                  </div> */}
                <h4>Fat Metabolism</h4>
                {/* <div className={getIcon("Fat Metabolism")}><span className="number1">{data["gut-scores"].find(item => item.title === "Fat Metabolism")?.score}</span></div> */}
                <div className={getIcon("Fat Metabolism")}><span className={getClass("Fat Metabolism")}>{data["gut-scores"].find(item => item.title === "Fat Metabolism")?.score}</span></div>

              </div>

              <div className="gutscore1">

                <div className={getIcon("Vitamin Synthesis")}><span className={getClass("Vitamin Synthesis")}>{data["gut-scores"].find(item => item.title === "Vitamin Synthesis")?.score}</span></div>
                <h4>Vitamin Synthesis</h4>
                <img src="page4/Vitamin Synthesis.png" style={{ width: "43px" }} alt="" />
                {/* <div className="hexagon-icon2">
                  <span className='p4icon'><img src="page4img/line5p4.png" alt="" /></span>
                  </div> */}
              </div>
              <div className="gutscore2">
                {/* <div className="hexagon-icon">

                  <span className='p4icon'><img src="page4img/line6p4.png" alt="" /></span>

                </div> */}
                <img src="page4/Lactose Sensitivity.png" style={{ width: "43px" }} alt="" />
                <h4>Lactose Sensitivity</h4>
                {/* <div className={getIcon("Lactose Sensitivity")}><span className="number">{data["gut-scores"].find(item => item.title === "Lactose Sensitivity")?.score}</span></div> */}
                <div className={getIcon("Lactose Sensitivity")}><span className={getClass("Lactose Sensitivity")}>{data["gut-scores"].find(item => item.title === "Lactose Sensitivity")?.score}</span></div>
              </div>
              <div className="gutscore1">
                <div className={getIcon("Gluten Sensitivity")}><span className={getClass("Gluten Sensitivity")}>{data["gut-scores"].find(item => item.title === "Gluten Sensitivity")?.score}</span></div>
                <h4>Gluten Sensitivity</h4>
                <img src="page4/Gluten Sensitivity.png" style={{ width: "43px" }} alt="" />
                {/* <div className="hexagon-icon2">
                  <span className='p4icon'><img src="page4img/line7p4.png" alt="" /></span>
                  </div> */}
              </div>
              <div className="gutscore2">
                {/* <div className="hexagon-icon">
                  <span className='p4icon'><img src="page4img/line8p4.png" alt="" /></span>
                  </div> */}
                <img src="page4/Sugar Index.png" style={{ width: "43px" }} alt="" />
                <h4>Sugar Index</h4>
                <div className={getIcon("Sugar Index")}><span className='number1'>{data["gut-scores"].find(item => item.title === "Sugar Index")?.score}</span></div>
              </div>
              <div className="gutscore1">
                <div className={getIcon("Processed Food Index")}><span className={getClass("Processed Food Index")}>{data["gut-scores"].find(item => item.title === "Processed Food Index")?.score}</span></div>
                <h4>Processed Food Index</h4>
                <img src="page4/Processed Food Index.png" style={{ width: "43px" }} alt="" />
                {/* <div className="hexagon-icon2">
                  <span className='p4icon'><img src="page4img/line9p4.png" alt="" /></span>


                  </div> */}
              </div>
              <div className="gutscore2">
                {/* <div className="hexagon-icon">
                  <span className='p4icon'><img src="page4img/line10p4.png" alt="" /></span>

                </div> */}
                {/* <img src="page4/Bowel Mobility .png" style={{ width: "43px" }} alt="" />
                <h4>Bowel Mobility</h4> */}
                <img src="page4/Bowel Mobility.png" style={{ width: "43px" }} alt="" />
                <h4>Bowel Mobility</h4>
                {/* <div className={getIcon("Bowel Mobility")}><span className="number">{data["gut-scores"].find(item => item.title === "Bowel Mobility")?.score}</span></div> */}
                <div className={getIcon("Bowel Mobility")}><span className={getClass("Bowel Mobility")}>{data["gut-scores"].find(item => item.title === "Bowel Mobility")?.score}</span></div>
              </div>
              <div className="gutscore1">

                <div className={getIcon("Antibiotic Damage")}><span className={getClass("Antibiotic Damage")}>{data["gut-scores"].find(item => item.title === "Antibiotic Damage")?.score}</span></div>
                <h4>Antibiotic Damage</h4>
                <img src="page4/Antibiotic Damage.png" style={{ width: "43px" }} alt="" />
                {/* <div className="hexagon-icon2">
                  <span className='p4icon'><img src="page4img/line11p4.png" alt="" /></span>
                  </div> */}
              </div>
              <div className="gutscore2">
                {/* <div className="hexagon-icon">
                  <span className='p4icon'><img src="page4img/line12p4.png" alt="" /></span>

                </div> */}
                <img src="page4/Autoimmune Index.png" style={{ width: "43px" }} alt="" />
                <h4>Autoimmune Index</h4>
                <div className={getIcon("Autoimmune Index")}><span className={getClass("Autoimmune Index")}>{data["gut-scores"].find(item => item.title === "Autoimmune Index")?.score}</span></div>
              </div>
              <div className="gutscore1">
                {/* <div className={getIcon("Sleep Quality")}><span className="number">{data["gut-scores"].find(item => item.title === "Sleep Quality")?.score}</span></div> */}
                <div className={getIcon("Sleep Quality")}><span className={getClass("Sleep Quality")}>{data["gut-scores"].find(item => item.title === "Sleep Quality")?.score}</span></div>
                <h4>Sleep Quality</h4>
                <img src="page4/Sleep Quality.png" style={{ width: "43px" }} alt="" />
                {/* <div className="hexagon-icon2">
                  <span className='p4icon'><img src="page4img/line13p4.png" alt="" /></span>

                </div> */}
              </div>

            </div>


          </div>

          <Footer />
        </div>


        {/* page 5*/}
        <div id="page5" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Your Microbiome Age</h2>
            <div className="text2">
              <div>
                <div className="" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <img src={getImageSrc("microbiome-age-range", "Your Microbiome Age")} style={{ margin: "0px", padding: "0px", width: "115px" }} alt="" />
                  <h1 style={{ fontSize: "48px", fontWeight: "500", position: "absolute", color: getColor("microbiome-age-range", "Your Microbiome Age") }}>{data["microbiome-age-range"][1].score}</h1>
                </div>
                {/* <div className="hexagon-large"><span className="hxalargetext"><h1>{data["microbiome-age-range"][1].score}</h1></span></div> */}
              </div>
              {/* <h4 style={{fontStyle:"italic",color: getColor("microbiome-age-range", 1)}}>It appears that your microbiome is younger than you! The personalized nutrition plan we've put together for you, will help you keep your microbiome young longer!</h4> */}
              <h4 style={{ fontStyle: "italic", color: getColor("microbiome-age-range", "Your Microbiome Age") }}>{getPara("age")}
              </h4>
            </div>
            <p>If the microbiome age is less than the chronological age or closer to the chronological age, it indicates that your bacterial profile mirrors that of someone who is roughly your age or younger. On the other hand, if your microbiome age is older than your chronological age it can indicate the opposite, that your bacterial profile is more consistent with that of someone older than yourself</p>
            <p>We can't change our age, but what about microbiome's age? Based on the science, that may very well be possible with personalized lifestyle and nutrition.</p>
            <h2 style={{ marginTop: "15mm" }}>Your Microbiome Diversity</h2>
            <div className="text2">
              <div>
                {/* <div className="hexagon-large-red"><span className="hxalargetext"><h1>{data["microbiome-age-range"][0].score}</h1></span></div> */}
                <div className="" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <img src={getImageSrc("microbiome-age-range", "Your Microbiome Diversity")} style={{ margin: "0px", padding: "0px", width: "115px" }} alt="" />
                  <h1 style={{ fontSize: "48px", fontWeight: "500", position: "absolute", color: getColor("microbiome-age-range", "Your Microbiome Diversity") }}>{data["microbiome-age-range"][0].score}</h1>
                </div>
              </div>
              {/* <h4 style={{fontStyle:"italic",color: getColor("microbiome-age-range", 0)}}>Poor, With Need For Improvement: Although you have a pretty low level of diversity, our personalized nutrition plan will help you improve it and achieve a more diverse microbiome.</h4> */}
              <h4 style={{ fontStyle: "italic", color: getColor("microbiome-age-range", "Your Microbiome Diversity") }}>{getPara("diversity")}</h4>
            </div>
            <p>The microbiome diversity score is an important indicator of general health that outlines the number of bacterial species present in the intestines and how evenly distributed each species is.</p>
            <p>The scores in the range of 0-5, which are color-coded red, indicate an insufficient
              number and uneven distribution of the bacterial species in the gut.</p>
            <p>The scores in the range of 5-8, which are color-coded yellow, indicate an average or moderately good diversity and distribution.</p>
            <p>The scores in the range of 8-10, which are color-coded blue, indicate that the individual has a very good/excellent diversity and a well-balanced distribution.</p>

          </div>
          <Footer />
        </div>


        {/* page 6*/}
        <div id="page6" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Your Taxonomic Anyalsis</h2>
            <div className="text1">
              <div>
                <div className="page6img">
                  <img src="page6img.png" alt="" />
                </div>

              </div>
              <p><strong>"Taxanomy"</strong>is the science in which every living thing is classified and named by scientists according to their common character within a given system. Every living thing in nature has a taxonomic classification. For example, the domestic cats living among us are classified "house cat and its close relatives" as a genus, "felines" as a family, "Carnies" as an order, "Chordals" as a phylum, as "Animals" as the regnum. Each group here is called "taxa" and bacteria are likewise grouped in different taxa according to their common character.</p>

            </div>
            <h2 style={{ fontStyle: "italic", fontWeight: "500", fontSize: "20px", marginBottom: "15mm" }}>Taxonomic analysis denotes level ratios at the stage of the genus, family and branch of bacteria that exist in your microbiome.</h2>



            <h3>{data["taxonomic"][0].title}</h3>
            <p>{data["taxonomic"][0].desc}</p>

            {/* <h5>Your Profile</h5>
            <div className="percantagebar">
              {data["taxonomic"][0].bacteria.map((bacterium, index) => (
                <div
                  key={index}
                  className={`percantagebarcolor` + index}
                  style={{ width: `${bacterium.your_profile}` }}
                  // style={{ width:"24mm"}}
                >
                  <span className="percantagebar-cercle">  <h6>{bacterium.your_profile}%</h6></span>
                </div>
              ))}
            </div> */}
            <h5>Your Profile</h5>
            {/* <div className="percantagebar">
  {data["taxonomic"][0].bacteria.map((bacterium, index) => {
    console.log(`Bacterium ${index}:`, bacterium.your_profile); // Logs each your_profile value
    
    return (
      <div
        key={index}
        className={`percantagebarcolor` + index}
        style={{ width: `${bacterium.your_profile}%` }}
      >
        <span className="percantagebar-cercle">
          <h6>{bacterium.your_profile}%</h6>
        </span>
      </div>
    );
  })}
</div> */}
            <div className="percantagebar">
              {data["taxonomic"][0].bacteria.map((bacterium, index) => {
                // Check if `your_profile` is less than 10, and if so, add 5 to it
                const profileWidth = bacterium.your_profile < 15 ? bacterium.your_profile + 10 : bacterium.your_profile;

                // console.log(`Bacterium ${index}:`, profileWidth); // Logs adjusted your_profile value

                return (
                  <div
                    key={index}
                    className={`percantagebarcolor` + index}
                    style={{ width: `${profileWidth * 2}mm` }}
                  >
                    <span className="percantagebar-cercle">
                      <h6>{bacterium.your_profile}%</h6>
                    </span>
                  </div>
                );
              })}
            </div>

            <div className="color-box">
              {data["taxonomic"][0].bacteria.slice(0, 6).map((bacterium, index) => (
                <h6 style={{ fontWeight: "600" }} key={index}>
                  <div className={"color" + (index + 1)}></div>
                  {bacterium.name}
                </h6>
              ))}
            </div>

            <div className="color-box">
              {data["taxonomic"][0].bacteria.slice(6).map((bacterium, index) => (
                <h6 style={{ fontWeight: "600" }} key={index + 6}>
                  <div className={"color" + (index + 7)}></div>
                  {bacterium.name}
                </h6>
              ))}
            </div>


            <h5>World Average</h5>
            <div className="percantagebar">
              {data["taxonomic"][0].bacteria.map((bacterium, index) => {
                // Check if `your_profile` is less than 10, and if so, add 5 to it
                const profileWidth = bacterium.community < 15 ? bacterium.community + 15 : bacterium.community;

                // console.log(`Bacterium ${index}:`, profileWidth); // Logs adjusted your_profile value

                return (
                  <div
                    key={index}
                    className={`percantagebarcolor` + index}
                    style={{ width: `${profileWidth * 2}mm` }}
                  >
                    <span className="percantagebar-cercle">
                      <h6>{bacterium.community}%</h6>
                    </span>
                  </div>
                );
              })}
            </div>
            {/* <div className="percantagebar">
              {data["taxonomic"][0].bacteria.map((bacterium, index) => (
                <div
                  key={index}
                  className={`percantagebarcolor` + index}
                  style={{ width: `${bacterium.community < 5.5 ? 5.5 : bacterium.community}%` }} // Conditional width
                >
                  <span className="percantagebar-cercle">
                    <h6>{bacterium.community}%</h6>
                  </span>
                </div>
              ))}
            </div> */}

            {/* <div className="color-box">
              {data["taxonomic"][0].bacteria.map((bacterium, index) => (
                <h6><div className={"color" + (index + 1)}></div>Akkermansia </h6>
              ))}
            </div> */}

            <div className="color-box">
              {data["taxonomic"][0].bacteria.slice(0, 6).map((bacterium, index) => (
                <h6 style={{ fontWeight: "600" }} key={index}>
                  <div className={"color" + (index + 1)}></div>
                  {bacterium.name}
                </h6>
              ))}
            </div>

            <div className="color-box">
              {data["taxonomic"][0].bacteria.slice(6).map((bacterium, index) => (
                <h6 style={{ fontWeight: "600" }} key={index + 6}>
                  <div className={"color" + (index + 7)}></div>
                  {bacterium.name}
                </h6>
              ))}
            </div>




            {/* <h5>World Average</h5>
            <div className="percentage-bar">
              {data["taxonomic"][0].bacteria.map((bacterium, index) => (
                <div
                  key={index}
                  className={`percentage-bar-section color-${index + 1}`}
                  style={{ width: `${bacterium.community}%` }}
                >
                  <h6>{bacterium.community}%</h6>
                </div>
              ))}
            </div>

            <div className="color-legend">
              {data["taxonomic"][0].bacteria.map((bacterium, index) => (
                <h6 key={index}>
                  <span className={`legend-color color-${index + 1}`}></span> {bacterium.name}
                </h6>
              ))}
            </div> */}






          </div>
          <Footer />
        </div>


        {/* page 7*/}
        <div id="page7" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Important Bacteria</h2>

            {data["bacteria"].map((value, index) => {
              let show = true

              let top = `${value.scores[0].score}`
              let bottom = `${value.scores[1].score}`

              if (index > 4) {
                show = false
              }
              return (<>

                {show === true && <>
                  <div className="bacteria-box">
                    <h3>{value.name}</h3>
                    <div class="gradient-bar-container">
                      <div style={{ left: top + "%" }} class="marker marker-left">
                        <div class="marker-label">Your Profile</div>
                        <div class="marker-value">{top}</div>
                        <div class="marker-arrow-top"></div>
                      </div>
                      <div style={{ left: bottom + "%" }} class="marker marker-right">
                        <div class="marker-arrow-bottom"></div>
                        <div class="marker-value">{bottom}</div>
                        <div class="marker-label">Community</div>
                      </div>
                    </div>
                  </div>
                </>}
              </>)
            })}



          </div>

          <div className="" style={{ padding: '20px' }}></div>
          <Footer />
        </div>


        {/* page 8
        <div id="page8">
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            {data["bacteria"].map((value, index) => {
              let show = false

              let top = `${value.scores[0].score}`
              let bottom = `${value.scores[1].score}`

              if (index >= 6 && index<=11) {
                show = true
              }
              return (<>

                {show === true && <>
                  <div className="bacteria-box">
                    <h3>{value.name}</h3>
                    <div class="gradient-bar-container">
                      <div style={{ left: top + "%" }} class="marker marker-left">
                        <div class="marker-label">Your Profile</div>
                        <div class="marker-value">{top}</div>
                        <div class="marker-arrow-top"></div>
                      </div>
                      <div style={{ left: bottom + "%" }} class="marker marker-right">
                        <div class="marker-arrow-bottom"></div>
                        <div class="marker-value">{bottom}</div>
                        <div class="marker-label">Community</div>
                      </div>
                    </div>
                  </div>
                </>}
              </>)
            })}



          </div>


          <Footer />

        </div> */}
        {/* page 8 */}
        <div id='page8' className='page1'>

          {data["bacteria"].some((_, index) => index > 6) && (
            <div id="page8">
              <Header  Kitinfo={data['Kitinfo']}/>
              <div className="text-box">
                {data["bacteria"].map((value, index) => {
                  let show = false;
                  let top = `${value.scores[0].score}`;
                  let bottom = `${value.scores[1].score}`;

                  if (index >= 5 && index <= 10) {
                    show = true;
                  }

                  return (
                    <>
                      {show && (
                        <div className="bacteria-box">
                          <h3>{value.name}</h3>
                          <div className="gradient-bar-container">
                            <div style={{ left: top + "%" }} className="marker marker-left">
                              <div className="marker-label">Your Profile</div>
                              <div className="marker-value">{top}</div>
                              <div className="marker-arrow-top"></div>
                            </div>
                            <div style={{ left: bottom + "%" }} className="marker marker-right">
                              <div className="marker-arrow-bottom"></div>
                              <div className="marker-value">{bottom}</div>
                              <div className="marker-label">Community</div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
              <Footer />
            </div>
          )}
        </div>

        {/* page 82
        <div id="page82">
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            {data["bacteria"].map((value, index) => {
              let show = false
              let top = `${value.scores[0].score}`
              let bottom = `${value.scores[1].score}`

              if (index >= 12 && index<=17) {
                show = true
              }
              return (<>

                {show === true && <>
                  <div className="bacteria-box">
                    <h3>{value.name}</h3>
                    <div class="gradient-bar-container">
                      <div style={{ left: top + "%" }} class="marker marker-left">
                        <div class="marker-label">Your Profile</div>
                        <div class="marker-value">{top}</div>
                        <div class="marker-arrow-top"></div>
                      </div>
                      <div style={{ left: bottom + "%" }} class="marker marker-right">
                        <div class="marker-arrow-bottom"></div>
                        <div class="marker-value">{bottom}</div>
                        <div class="marker-label">Community</div>
                      </div>
                    </div>
                  </div>
                </>}
              </>)
            })}



          </div>


          <Footer />

        </div> */}
        {/* page 82 */}
        <div id='page8' className='page1'>

          {data["bacteria"].some((value, index) => index > 12) && (
            <div id="page82">
              <Header  Kitinfo={data['Kitinfo']}/>
              <div className="text-box">
                {data["bacteria"].map((value, index) => {
                  let show = false;
                  let top = `${value.scores[0].score}`;
                  let bottom = `${value.scores[1].score}`;

                  if (index >= 11 && index <= 16) {
                    show = true;
                  }

                  return (
                    <>
                      {show && (
                        <div className="bacteria-box">
                          <h3>{value.name}</h3>
                          <div className="gradient-bar-container">
                            <div style={{ left: top + "%" }} className="marker marker-left">
                              <div className="marker-label">Your Profile</div>
                              <div className="marker-value">{top}</div>
                              <div className="marker-arrow-top"></div>
                            </div>
                            <div style={{ left: bottom + "%" }} className="marker marker-right">
                              <div className="marker-arrow-bottom"></div>
                              <div className="marker-value">{bottom}</div>
                              <div className="marker-label">Community</div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
              <Footer />
            </div>
          )}

        </div>
        {/* page 83
        <div id="page83">
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
          
            {data["bacteria"].map((value, index) => {
              let show = false
              let top = `${value.scores[0].score}`
              let bottom = `${value.scores[1].score}`

              if (index>17) {
                show = true
              }
              return (<>

                {show === true && <>
                  <div className="bacteria-box">
                    <h3>{value.name}</h3>
                    <div class="gradient-bar-container">
                      <div style={{ left: top + "%" }} class="marker marker-left">
                        <div class="marker-label">Your Profile</div>
                        <div class="marker-value">{top}</div>
                        <div class="marker-arrow-top"></div>
                      </div>
                      <div style={{ left: bottom + "%" }} class="marker marker-right">
                        <div class="marker-arrow-bottom"></div>
                        <div class="marker-value">{bottom}</div>
                        <div class="marker-label">Community</div>
                      </div>
                    </div>
                  </div>
                </>}
              </>)
            })}



          </div>


          <Footer />

        </div> */}
        {/* page 83 */}
        <div id='page8' className='page1'>

          {data["bacteria"].some((_, index) => index > 16) && (
            <div id="page83">
              <Header  Kitinfo={data['Kitinfo']}/>
              <div className="text-box">
                {data["bacteria"].map((value, index) => {
                  let show = false;
                  let top = `${value.scores[0].score}`;
                  let bottom = `${value.scores[1].score}`;

                  if (index > 17) {
                    show = true;
                  }

                  return (
                    <>
                      {show && (
                        <div className="bacteria-box">
                          <h3>{value.name}</h3>
                          <div className="gradient-bar-container">
                            <div style={{ left: top + "%" }} className="marker marker-left">
                              <div className="marker-label">Your Profile</div>
                              <div className="marker-value">{top}</div>
                              <div className="marker-arrow-top"></div>
                            </div>
                            <div style={{ left: bottom + "%" }} className="marker marker-right">
                              <div className="marker-arrow-bottom"></div>
                              <div className="marker-value">{bottom}</div>
                              <div className="marker-label">Community</div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
              <Footer />
            </div>
          )}

        </div>
        {/* page 9*/}
        <div id="page9" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Your Similar Profiles</h2>
            <p>Studies have shown that 90% of chronic diseases are linked to gut microbiome imbalance. As a result of these studies, it has also been observed that individuals with similar microbiome profiles may develop similar disorders.</p>
            <p>Our unique Al algorithms analyze microbiome profiles similar to yours, along with the lifestyle and health data from those profiles. The results of this analysis indicate those conditions that people with a similar to your microbiome profile have developed</p>
            <p>These data are not meant to be used for diagnostic purposes, but rather provide you with an opportunity to assess potential health risks and take steps to support each of these systems within an effort to maintain optimal health.</p>
            <p>The personalized nutrition guide we have prepared for you will also help support you in all of these areas.</p>
            <p><strong>The people within our database who have a similar microbiome profile with you presented with the following:</strong></p>
            <div className="loaders">


              {data["similar-profiles"].map((value) => {
                const radius = 36; // Radius of the circle
                const circumference = 2 * Math.PI * radius;
                const offset = circumference - (value.score / 100) * circumference;
                return (<>
                  <div className="loader1">
                    <h6 style={{ paddingBottom: "14px", whiteSpace: "pre-wrap" }}>{String(value.title).replace(/<br\s*\/?>/gi, "\n")}</h6>

                    {/* <div className="loader" style={{ background:`conic-gradient( #3498db ${value.score}%,#f3f3f3 0 )` }}>
                      <h4>{value.score}%</h4>
                    </div> */}
                    <svg width="80" height="80">
                      <circle
                        cx="40"
                        cy="40"
                        r={radius}
                        fill="none"
                        stroke="#f3f3f3"
                        strokeWidth="8"
                      />
                      <circle
                        cx="40"
                        cy="40"
                        r={radius}
                        fill="none"
                        stroke="#3498db"
                        strokeWidth="8"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        transform="rotate(-90 40 40)" // Rotate to start from the top
                      />
                      <text
                        x="50%"
                        y="50%"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        fontSize="1.5em"
                        fill="#2697D4"
                      >
                        {value.score}%
                      </text>

                    </svg>
                  </div>

                </>)
              })}

            </div>

            <p style={{fontSize:"11px"}}><strong>Note: </strong>Overall average, simply indicates how a particular condition compares to the entirety of the population of our microbiome biobank. Therefore, the only conditions listed are those that have a percentage above the Overall Average</p>

          </div>

          <Footer />
        </div>


        {/* page 10*/}
        <div id="page10" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Your Gut Scores</h2>
            <p>Our artificial intelligence algorithm has generated gut scores for 13 different parameters based on the type and number of bacteria in your gut.</p>
            <p>Do not interpret this report based on your current weight, health status, or how you are currently feeling. Here we are offering you a glimpse into what is happening in your inner world and possible predispositions.</p>
            <p>Each parameter is scored on a scale from 0 to 100. The red section of the line indicates that the score is outside the determined reference value and should be adjusted. Whereas the blue section indicates that the score is within the healthy limits and should be maintained. Again, the diet plan we lay out for you takes this into consideration and caters to the need to maintain those particular bacteria.</p>
            <p>The community score indicates the average value of all our data from communities around the globe. Because there are regional differences when it comes to microbiome profiles, we include data from various projects and initiatives that are collected from a variety of countries in order to provide the most accurate score.</p>

            <p>The personalized nutrition plan we lay out has been clinically proven to help you achieve and sustain good scores in each of the areas we assess.</p>
            <div className="page10img">
              <img src="page10img.png" alt="" /></div>
          </div>

          <Footer />
        </div>


        {/* page 11*/}
        <div id="page11" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">


            {
              data["gut-scores"].map((value) => {
                let show = false;
                if (value.title === "Metabolic Score") {
                  show = true;
                }


                let top = `${value.score}`


                let cssclass = ""
                let cssnumber = ""

                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }

                return (<>

                  {show && <>
                    <div className="text3">
                      <div>
                        {/* <div className="hexagon-largepurple" >
                        <span class="hxalargetext">
                          <img src="page4img/line1p4.png" alt="" />
                          </span>
                      </div> */}
                        <img style={{ width: '152px', marginTop: "20px" }} src={getImageSrc("gut-scores", "Metabolic Score", 'm')} alt="" />
                        {/* <img style={{width:'172px'}} src={"page4/Metabolic Score.png"} alt="" /> */}
                      </div>
                      <div>
                        <h2>{value.title}</h2>
                        {value.desc.map((item) => (<>
                          <p>{item}</p>
                        </>))}




                        <div class="gradient-bar-container-large-new" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                          <div style={{ left: top - 4 + "%" }} class="markermarker-left">
                            <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                            </div>
                            <div class="marker-value"></div>
                            <div class="marker-arrow-top"></div>
                          </div>

                          {value.average_scores.map((item, index) => (<>
                            {item.title !== "Community average" && <>
                              <div style={{ left: `calc(${item.value - 3}% + ${index * 10}px)` }} class="markermarker-right">
                                <div class="marker-arrow-bottom"></div>
                                <div class="marker-value">{item.value}</div>
                                <div class="marker-label">{item.title}</div>
                              </div>
                            </>}
                          </>))}


                          {value.average_scores.map((item, index) => (<>

                            {item.title === "Community average" && <>
                              <div style={{ left: `calc(${item.value - 11}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                                {/* <div class="marker-label" >{item.title}</div> */}
                                <div class="marker-label" style={{fontWeight:"bold"}} >Community</div>
                                <div class="marker-arrow-bottom"></div>
                                <div class="marker-value">{item.value}</div>

                              </div>
                            </>}
                          </>))}



                        </div>

                        <div className='page11center'>

                          <h2>Macronutrient Metabolism</h2>

                          <p>These scores evaluate the amount and activity of key microorganisms involved in carbohydrate, protein and fat metabolisms.</p>
                          <p>High scores indicate a large variety of bacteria within the gut that can aid in the body's ability to digest and utilize these macronutrients.</p>


                        </div>
                      </div>
                    </div>
                  </>}
                </>)
              })}



            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Carbohydrate Metabolism") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="page11text">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {/* <div className="hexagon-small-lightblue">
                        <span class="hxasmalltext"><img src="page4img/line2p4.png" alt="" /></span>
                      </div> */}
                      {/* <img style={{width:'77px'}} src="page4/Carbohydrate Metabolism.png" alt="" /> */}
                      <img style={{ width: '77px' }} src={getImageSrc("gut-scores", "Carbohydrate Metabolism", "carbo")} alt="" />
                      <h5 style={{ marginTop: "5px", marginLeft: "22px", width: '33mm', display: 'flex', justifyContent: "center" }}> {value.title}</h5>
                    </div>
                    <div>



                      <div class="gradient-bar-container-large-1" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 7}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>




                    </div>

                  </div>
                </>}
              </>)
            })}


            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Protein Metabolism") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="page11text">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {/* <div className="hexagon-small-lightblue">
                        <span class="hxasmalltext"><img src="page4img/line3p4.png" alt="" /></span>
                      </div> */}
                      {/* <img style={{width:'77px'}} src="page4/Protein Metabolism.png" alt="" /> */}
                      <img style={{ width: '77px', marginBottom: "5px" }} src={getImageSrc("gut-scores", "Protein Metabolism", "protein")} alt="" />
                      <h5 style={{ margin: "0", width: '44mm', display: 'flex', justifyContent: "center" }}> {value.title}</h5>
                    </div>
                    <div>



                      <div class="gradient-bar-container-large-1" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 8}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>




                    </div>

                  </div>
                </>}
              </>)
            })}

            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Fat Metabolism") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="page11text">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {/* <div className="hexagon-small-lightblue">
                        <span class="hxasmalltext"><img src="page4img/line4p4.png" alt="" /></span>
                      </div> */}
                      {/* <img style={{width:'77px'}} src="page4/Fat Metabolism.png" alt="" /> */}
                      <img style={{ width: '77px', marginBottom: "5px" }} src={getImageSrc("gut-scores", "Fat Metabolism", "fat")} alt="" />
                      <h5 style={{ margin: "0", width: '44mm', display: 'flex', justifyContent: "center" }}> {value.title}</h5>
                    </div>
                    <div>

{/* rgba(227, 99, 79, 1) 0%,rgba(238, 175, 130, 1) 12%,rgba(237, 209, 161, 1) 43%,rgba(89, 196, 217, 1) 100% */}

                      <div class="gradient-bar-container-large-1" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 10}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>




                    </div>

                  </div>
                </>}
              </>)
            })}





          </div>

          <Footer />
        </div>


        {/* page 12*/}
        <div id="page12" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Vitamin Synthesis") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="text3">
                    <div>
                      {/* <div className="hexagon-largepurple" >
                        <span class="hxalargetext"><img src="colorchange.png" alt="" /></span>

                      </div> */}
                      <img style={{ width: '152px', marginTop: "20px" }} src={getImageSrc("gut-scores", "Vitamin Synthesis", 'vitamin')} alt="" />
                    </div>
                    <div>
                      <h2>{value.title}</h2>
                      {value.desc.map((item) => (<>
                        <p>{item}</p>
                      </>))}

                      <div class="gradient-bar-container-large-1" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 9}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div
                                className="marker-label" style={{ lineHeight: "1" }}
                                dangerouslySetInnerHTML={{
                                  __html: item.title.replace(/ /g, '<br/>'),
                                }}
                              ></div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 7}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>


                      <div className='page11center'>

                        <h2 style={{ marginTop: "20mm" }}> Lactose and Gluten Sensitivity</h2>

                        <p>These scores evaluate the bacteria that are known to contribute
                          to a body’s ability to process lactose and gluten. They evaluate
                          the risk of developing lactose or gluten sensitivity, however, are
                          not meant to be used for diagnostic purposes.</p>
                        <p> High scores indicate that your body may have difficulty
                          processing lactose/ gluten while low or average scores indicate
                          that your body is in a position to effectively and efficiently
                          process lactose/gluten.</p>


                      </div>
                    </div>
                  </div>
                </>}
              </>)
            })}



            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Lactose Sensitivity") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="page11text">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {/* <div className="hexagon-small-lightblue">
                        <span class="hxasmalltext"><img src="page4img/line4p4.png" alt="" /></span>
                      </div> */}
                      <img style={{ width: '77px', marginBottom: "5px" }} src={getImageSrc("gut-scores", "Lactose Sensitivity", "lactose")} alt="" />
                      <h5 style={{ margin: "0", width: '44mm', display: 'flex', justifyContent: "center" }}> {value.title}</h5>
                    </div>
                    <div>



                      <div class="gradient-bar-container-large-new" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 4 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 9}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 6}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>




                    </div>

                  </div>
                </>}
              </>)
            })}
            <div className="gap"></div>

            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Gluten Sensitivity") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="page11text">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {/* <div className="hexagon-small-lightblue">
                        <span class="hxasmalltext"><img src="page4img/line4p4.png" alt="" /></span>
                      </div> */}
                      <img style={{ width: '77px', marginBottom: "5px" }} src={getImageSrc("gut-scores", "Gluten Sensitivity", "gluten")} alt="" />
                      <h5 style={{ margin: "0", width: '44mm', display: 'flex', justifyContent: "center" }}> {value.title}</h5>
                    </div>
                    <div>



                      <div class="gradient-bar-container-large-new" style={{ marginTop: "5mm" ,
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 2 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 6}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 2}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>




                    </div>

                  </div>
                </>}
              </>)
            })}


          </div>
          <Footer />
        </div>


        {/* page 13*/}
        <div id="page13" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Sugar Index") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="text3">
                    <div>
                      {/* <div className="hexagon-largepurple" >
                        <span class="hxalargetext"><img src="colorchange.png" alt="" /></span>

                      </div> */}
                      <img style={{ width: '152px', marginTop: "20px" }} src={getImageSrc("gut-scores", "Sugar Index", 'sugar')} alt="" />
                    </div>
                    <div>
                      <h2>{value.title}</h2>
                      {value.desc.map((item) => (<>
                        <p>{item}</p>
                      </>))}

                      <div class="gradient-bar-container-large-new" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 10}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 10}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>



                    </div>
                  </div>
                </>}
              </>)
            })}
            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Processed Food Index") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="text3">
                    <div>
                      {/* <div className="hexagon-largepurple" >
                        <span class="hxalargetext"><img src="colorchange.png" alt="" /></span>

                      </div> */}
                      <img style={{ width: '152px', marginTop: "20px" }} src={getImageSrc("gut-scores", "Processed Food Index", 'processed')} alt="" />
                    </div>
                    <div>
                      <h2>{value.title}</h2>
                      {value.desc.map((item) => (<>
                        <p>{item}</p>
                      </>))}

                      <div class="gradient-bar-container-large-new" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 3 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 16}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 4}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>



                    </div>
                  </div>
                </>}
              </>)
            })}

          </div>



          <Footer />
        </div>


        {/* page 14*/}
        <div id="page14" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Bowel Mobility") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }
              return (<>

                {show && <>
                  <div className="text3">
                    <div>
                      {/* <div className="hexagon-largepurple" >
                        <span class="hxalargetext"><img src="colorchange.png" alt="" /></span>

                      </div> */}
                      <img style={{ width: '152px', marginTop: "20px" }} src={getImageSrc("gut-scores", "Bowel Mobility", 'bowel')} alt="" />
                    </div>
                    <div>
                      <h2>{value.title}</h2>
                      {value.desc.map((item) => (<>
                        <p>{item}</p>
                      </>))}

                      <div class="gradient-bar-container-large-new" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 8.5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 21}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 8}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>



                    </div>
                  </div>
                </>}
              </>)
            })}
            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Antibiotic Damage") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }

              return (<>

                {show && <>
                  <div className="text3">
                    <div>
                      {/* <div className="hexagon-largepurple" >
                        <span class="hxalargetext"><img src="colorchange.png" alt="" /></span>

                      </div> */}
                      <img style={{ width: '152px', marginTop: "20px" }} src={getImageSrc("gut-scores", "Antibiotic Damage", 'anti')} alt="" />
                    </div>
                    <div>
                      <h2>{value.title}</h2>
                      {value.desc.map((item) => (<>
                        <p>{item}</p>
                      </>))}

                      <div class="gradient-bar-container-large-new" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 13}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 7}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>



                    </div>
                  </div>
                </>}
              </>)
            })}

          </div>



          <Footer />


        </div>


        {/* page 15*/}
        <div id="page15" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Autoimmune Index") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }

              return (<>

                {show && <>
                  <div className="text3">
                    <div>
                      {/* <div className="hexagon-largepurple" >
                        <span class="hxalargetext"><img src="colorchange.png" alt="" /></span>

                      </div> */}
                      <img style={{ width: '152px', marginTop: "20px" }} src={getImageSrc("gut-scores", "Autoimmune Index", 'auto')} alt="" />
                    </div>
                    <div>
                      <h2>{value.title}</h2>
                      {value.desc.map((item) => (<>
                        <p>{item}</p>
                      </>))}

                      <div class="gradient-bar-container-large-new" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 12}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 5}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>



                    </div>
                  </div>
                </>}
              </>)
            })}
            {data["gut-scores"].map((value) => {
              let show = false;
              if (value.title === "Sleep Quality") {
                show = true;
              }
              let top = `${value.score}`


              let cssclass = ""
              let cssnumber = ""

              if (value.flag === "good") {
                cssclass = "plus-icon"
                cssnumber = "number2"
              } else if (value.flag === "average") {
                cssclass = "rhombus-icon"
                cssnumber = "number1"
              } else if (value.flag === "bad") {
                cssclass = "x-icon"
                cssnumber = "number1"
              }

              return (<>

                {show && <>
                  <div className="text3">
                    <div>
                      {/* <div className="hexagon-largepurple" >
                        <span class="hxalargetext"><img src="colorchange.png" alt="" /></span>

                      </div> */}
                      <img style={{ width: '152px', marginTop: "20px" }} src={getImageSrc("gut-scores", "Sleep Quality", 'sleep')} alt="" />
                    </div>
                    <div>
                      <h2>{value.title}</h2>
                      {value.desc.map((item) => (<>
                        <p>{item}</p>
                      </>))}

                      <div class="gradient-bar-container-large-1" style={{
                        background: `linear-gradient(to right,${value.barGradientColor})`
                      }}>
                        <div style={{ left: top - 5 + "%" }} class="markermarker-left">
                          <div className={cssclass}><span className={cssnumber}>   {value.score}</span>
                          </div>
                          <div class="marker-value"></div>
                          <div class="marker-arrow-top"></div>
                        </div>

                        {value.average_scores.map((item, index) => (<>
                          {item.title !== "Community average" && <>
                            <div style={{ left: `calc(${item.value - 15}% + ${index * 10}px)` }} class="markermarker-right">
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>
                              <div class="marker-label">{item.title}</div>
                            </div>
                          </>}
                        </>))}


                        {value.average_scores.map((item, index) => (<>

                          {item.title === "Community average" && <>
                            <div style={{ left: `calc(${item.value - 9}% + ${index * 10}mm)`, bottom: "-10.5mm" }} class="markermarker-right">
                              <div class="marker-label" style={{fontWeight:"bold"}}>Community</div>
                              {/* <div class="marker-label">{item.title}</div> */}
                              <div class="marker-arrow-bottom"></div>
                              <div class="marker-value">{item.value}</div>

                            </div>
                          </>}
                        </>))}



                      </div>


                    </div>
                  </div>
                </>}
              </>)
            })}

          </div>



          <Footer />



        </div>


        {/* page 16*/}
        <div id="page16" className='page1'></div>


        {/* page 17*/}
        <div id="page17" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Manage Your Nutrition!</h2>
            <p>Different bacterial species require different nutrients. The purpose of a personalized diet is to increase the number of bacteria needed to maintain the balance of the microbiome, while reducing the number of bacteria that cause an imbalance. This personalized nutrition guide helps balance your microbiome by selectively feeding the right bacteria in your gut.</p>
            <p>You can modulate your microbiome to achieve better health by knowing which foods are most beneficial and consuming more of those foods.</p>
            <p>This report presents you with the most suitable and specific foods for your needs, along with their scores.</p>
            <p>The scores are interpreted as follows:</p>
            <p> Eat less of the <span className='color-red'>nutrients that are scored between 0 and 3</span></p>
            <p>Eat <span className='color-yellow'>nutrients that are scored between 4 and 7 </span>for a balanced and varied diet</p>
            <p className='flex'>Enrich your diet with the <h4>nutrients that are scored between 8 and 10
            </h4></p>

            <h2>Please keep in mind that,</h2>
            <p><strong>Microbiome analysis is not a food intolerance test. </strong>While the foods with high scores may be just what your microbiome needs, they can also be the foods that you are allergic or intolerant to. If you are aware of such allergy or intolerance, you must disregard the recommendation containing those foods.</p>
          </div>


          <Footer />
        </div>


        {/* page 18*/}
        <div id="page18" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Here's Your Food!</h2>
            <div className="food">


              {data["food-scores"]
                .filter((value) => value.score >= 8 && value.score <= 10) // Filter for scores between 8 and 10
                .slice(0, 6) // Get the top 6 items
                .map((value, index) => {
                  let cssclass = ""
                  let cssnumber = ""


                  if (value.flag === "good") {
                    cssclass = "plus-icon"
                    cssnumber = "number2"
                  } else if (value.flag === "average") {
                    cssclass = "rhombus-icon"
                    cssnumber = "number1"
                  } else if (value.flag === "bad") {
                    cssclass = "x-icon"
                    cssnumber = "number1"
                  }
                  return (
                    <div key={value.id} className="food-box">
                      <h5>{value.name}</h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>

                    </div>
                  );
                })}



            </div>








            <h2><span className='color-yellow'>  Foods That Fit With You!</span></h2>
            <div className="food">


              {data["food-scores"]
                .filter((value) => value.score >= 4 && value.score <= 7) // Filter for scores between 8 and 10
                .slice(0, 6) // Get the top 6 items
                .map((value, index) => {
                  let cssclass = ""
                  let cssnumber = ""


                  if (value.flag === "good") {
                    cssclass = "plus-icon"
                    cssnumber = "number2"
                  } else if (value.flag === "average") {
                    cssclass = "rhombus-icon"
                    cssnumber = "number1"
                  } else if (value.flag === "bad") {
                    cssclass = "x-icon"
                    cssnumber = "number1"
                  }
                  return (
                    <div key={value.id} className="food-box">
                      <h5>{value.name}</h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>

                    </div>
                  );
                })}




            </div>







            <h2><span className='color-red'>  Foods To Avoid!</span></h2>
            <div className="food">


              {data["food-scores"]
                .filter((value) => value.score >= 0 && value.score <= 3) // Filter for scores between 8 and 10
                .slice(0, 6) // Get the top 6 items
                .map((value, index) => {
                  let cssclass = ""
                  let cssnumber = ""


                  if (value.flag === "good") {
                    cssclass = "plus-icon"
                    cssnumber = "number2"
                  } else if (value.flag === "average") {
                    cssclass = "rhombus-icon"
                    cssnumber = "number1"
                  } else if (value.flag === "bad") {
                    cssclass = "x-icon"
                    cssnumber = "number1"
                  }
                  return (
                    <div key={value.id} className="food-box">
                      <h5>{value.name}</h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>

                    </div>
                  );
                })}




            </div>





          </div>



          <Footer />
        </div>


        {/* page 19*/}
        <div id="page19" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Milk and dairy Products</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath


                let show = false
                let cssclass = ""
                let cssnumber = ""




                if (value.categories.some(category => category.name === "Milk and Dairy Products")) {
                  show = true;
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}



              {/* <div className="product">
              <div className="icon-box"></div>
              <h5>
                Sour Cream
              </h5>
              <div className="rhombus-icon"><span className='number1'>7</span></div>
            </div>

            <div className="product">
              <div className="icon-box"></div>
              <h5>
                Sour Cream
              </h5>
              <div className="rhombus-icon"><span className='number1'>7</span></div>
            </div> */}

            </div>





          </div>



          <Footer />
        </div>


        {/* page 20*/}
        <div id="page20" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Cheese Types</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Cheese Types")) {
                  // show = true;
                  cheese1 = cheese1 + 1
                  if (cheese1 < 25) {
                    show = true
                  }
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>




          </div>



          <Footer />
        </div>
        <div id="page20" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            {/* <h2>Cheese Types</h2> */}
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Cheese Types")) {
                  // show = true;
                  cheese2 = cheese2 + 1
                  if (cheese2 > 24) {
                    show = true
                  }
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>




          </div>



          <Footer />
        </div>


        {/* page 21*/}
        <div id="page21" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Meat and Eggs</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Meat and Eggs")) {
                  show = true;
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>


          </div>



          <Footer />




        </div>


        {/* page 22.1*/}
        <div id="page22" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Fish and Seafood</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Fish and Seafood")) {
                  fish1 = fish1 + 1
                  if (fish1 < 25) {
                    show = true
                  }
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>



          </div>



          <Footer />



        </div>
        <div id="page22" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Fish and Seafood</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Fish and Seafood")) {
                  // show = true;
                  fish2 = fish2 + 1
                  if (fish2 > 24) {
                    show = true
                  }
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>



          </div>



          <Footer />



        </div>



        {/* page 23*/}
        <div id="page23" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Bread and Cereals</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Bread and Cereals")) {
                  // show = true;
                  BreadandCereals = BreadandCereals + 1
                  if (BreadandCereals < 27) {
                    show = true
                  }

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>



          </div>



          <Footer />

        </div>


        {/* page 24*/}
        <div id="page24" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Bread and Cereals")) {
                  // show = true;
                  BreadandCereals2 = BreadandCereals2 + 1
                  if (BreadandCereals2 > 26) {
                    show = true
                  }

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>


          </div>
          <Footer />
        </div>


        {/* page 25*/}
        <div id="page25" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Legume and Legume-based Products</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Legume and Legume-based Products")) {
                  // show = true;

                  show = true


                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>


          </div>
          <Footer />
        </div>


        {/* page 26*/}
        <div id="page26" className='page1'>


          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Vegetables</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Vegetables")) {
                  // show = true;

                  Vegetablessss = Vegetablessss + 1
                  if (Vegetablessss < 27) {
                    show = true
                  }



                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>


          </div>



          <Footer />



        </div>


        {/* page 27*/}
        <div id="page27" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Vegetables")) {
                  // show = true;

                  Vegetablessss2 = Vegetablessss2 + 1
                  if (Vegetablessss2 > 26 && Vegetablessss2 < 51 ) {
                    show = true
                  }



                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>

          </div>



          <Footer />
        </div>
        <div id="page27" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Vegetables")) {
                  // show = true;

                  Vegetablessss3 = Vegetablessss3 + 1
                  if (Vegetablessss3 > 50 ) {
                    show = true
                  }



                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>

          </div>



          <Footer />
        </div>


        {/* page 28*/}
        {/* <div id="page28">
        <Header  Kitinfo={data['Kitinfo']}/>
        <div className="text-box">
          <div className="product-box">
            <div className="product">
              <div className="icon-box"></div>
              <h5>
                Taro Root
              </h5>
              <div className="x-icon"><span className='number1'>2</span></div>
            </div>
            <div className="product">
              <div className="icon-box"></div>
              <h5>
                Chilli
              </h5>
              <div className="x-icon"><span className='number1'>2</span></div>
            </div>

          </div>
        </div>
        <Footer />
      </div> */}


        {/* page 29*/}
        <div id="page29" className='page1'>


          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Fruits</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Fruits")) {
                  // show = true;
                  Fruitssss = Fruitssss + 1
                  if (Fruitssss < 25) {
                    show = true
                  }

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>

          </div>



          <Footer />




        </div>


        {/* page 30*/}
        <div id="page30" className='page1'>



          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Fruits")) {
                  // show = true;
                  Fruitssss2 = Fruitssss2 + 1
                  if (Fruitssss2 > 24 && Fruitssss2 < 49) {
                    show = true
                  }

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>
          </div>



          <Footer />



        </div>
        <div id="page30" className='page1'>



          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Fruits")) {
                  // show = true;
                  Fruitssss3 = Fruitssss3 + 1
                  if (Fruitssss3 > 48) {
                    show = true
                  }

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>
          </div>



          <Footer />



        </div>


        {/* page 31*/}
        <div id="page31" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Oil and Fats</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Oil and Fats")) {
                  // show = true;

                  show = true


                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>


          </div>



          <Footer />




        </div>


        {/* page 32*/}
        <div id="page32" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Nut and Seeds</h2>

            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Nut and Seeds")) {
                  // show = true;

                  show = true


                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>

          </div>



          <Footer />



        </div>


        {/* page 33*/}
        <div id="page33" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Drinks</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Drinks")) {
                  // show = true;
                  drinkssss = drinkssss + 1
                  if (drinkssss < 27) {
                    show = true
                  }
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>

          </div>



          <Footer />



        </div>


        {/* page 34*/}
        <div id="page34" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">



            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Drinks")) {
                  // show = true;
                  drinkssss2 = drinkssss2 + 1
                  if (drinkssss2 > 26) {
                    show = true
                  }
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>


          </div>

          <Footer />
        </div>


        {/* page 35*/}
        <div id="page35" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Herb, Spice and Sauces</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Herb, Spice and Sauces")) {
                  // show = true;

                  herbs = herbs + 1
                  if (herbs < 27) {
                    show = true
                  }

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>

          </div>



          <Footer />



        </div>



{/* page 35 part 2 */}
<div id="page34" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">



            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Herb, Spice and Sauces")) {
                  // show = true;
                  herbs2 = herbs2 + 1
                  if (herbs2 > 26) {
                    show = true
                  }
                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>


          </div>

          <Footer />
        </div>

        {/* page 36*/}
        <div id="page36" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">

            <h2>Supplements</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Supplements")) {
                  // show = true;

                  show = true

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>



          </div>

          <Footer />
        </div>


        {/* page 37*/}
        <div id="page37" className='page1'>

          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Others</h2>
            <div className="product-box">

              {data["food-scores"].map((value, index) => {
                const url = new URL(value.imageUrl);

                // Extract the pathname
                const imagePath = url.pathname;


                let imageUrl = imagePath

                let show = false
                let cssclass = ""
                let cssnumber = ""



                if (value.categories.some(category => category.name === "Others")) {
                  // show = true;

                  show = true

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>

                  {show && <>
                    <div className="product">
                      <div className="icon-box">
                        <img src={imageUrl} width={"100%"} />
                      </div>
                      <h5>
                        {value.name}
                      </h5>
                      <div className={cssclass}><span className={cssnumber}>   {value.score}</span></div>
                    </div>
                  </>}
                </>)
              })}




            </div>


          </div>



          <Footer />



        </div>


        {/* page 38*/}
        {/* <div id="page38" width="100%" height="10px"></div> */}

        {/* page 39*/}
        {/* <div style={{ height: "1px", width: "210mm" }}></div>
        <div id="page39" className='page1'>
          <Header  Kitinfo={data['Kitinfo']}/>
          <div className="text-box">
            <h2>Know Which Supplements Are Best for You!</h2>
            <p>By producing health-promoting molecules, regulating our metabolism, and communicating with our organs, probiotic organisms can have a significantly beneficial impact on human health and modulate our immune system. With their boosting effect on probiotics, prebiotics serve as nutrient sources for these beneficial bacteria. However, not every probiotic and prebiotic supplement works for everyone.</p>
            <p>The mode of action of probiotics is through a synergistic microbiome interaction via diverse pathways in unique ways. It has been difficult and unpredictable to determine if a certain probiotic supplement would be effective on an individual since every individual's microbiome needs are unique. Since each bacterium requires different prebiotics to be nourished, the prebiotic needs of individuals also differ.</p>

            <p>This microbiome analysis captures the needs of a person's microbiome by analyzing the whole genomic content of the microbiome at high resolution. By revealing the functional properties of your microbiome at the genetic level, we detect which enzymes your gut microbes are capable of producing, which health-promoting pathways are missing in your microbiome, and which bacteria would fill in this gap along with which prebiotic will nourish it and act as beneficial partners. Through an intensive evaluation of how they would act synergistically by introducing new molecules, closing gapped metabolic/signaling pathways in the ecosystem, and promoting the circles of other beneficial organisms by cross-feeding, the algorithms propose and rate the fittest probiotics and prebiotics for you.</p>
            <div className="page39">
              <img src="page39.png" alt="" />
            </div>
          </div>

          <Footer />
        </div> */}


        {/* page 40*/}
        {/* <div id="page40">
          <Header  Kitinfo={data['Kitinfo']}/>

          <div className="text-box">

            <h2>prebiotics</h2>
            <div className="page40maindiv">

              {data["supplements"].map((value, index) => {

                let show = false
                let cssclass = ""
                let cssnumber = ""

                if (value.categories.some(category => category.name === "Supplements")) {
                  // show = true;

                  show = true

                }



                if (value.flag === "good") {
                  cssclass = "plus-icon"
                  cssnumber = "number2"
                } else if (value.flag === "average") {
                  cssclass = "rhombus-icon"
                  cssnumber = "number1"
                } else if (value.flag === "bad") {
                  cssclass = "x-icon"
                  cssnumber = "number1"
                }


                return (<>
                  <div className="page40box">
                    <div style={{ width: '100px', height: '100px' }} className="icon-box">
                      <img src={imageUrl} width={"100%"} />
                    </div>
                    <div className="text">
                      <h5>Bio-Glucan Plus</h5>
                      <p>Pharma Nord</p>
                    </div>
                    <div className={cssclass}><span className={cssnumber}> {value.score} </span></div>
                  </div>

                </>)
              })}










            </div>

          </div>
          <Footer />
        </div> */}


        {/* page 41*/}
        <div id="page41" style={{marginTop:"1px", marginLeft:"0.49px",backgroundColor:"#a1421d"}} className=''>

          <img src="lastpageimg.png" alt="" />
          <p style={{ color: "white" }}>www.spacegut.com</p>
        </div>
      </div>





    </>)}
  </div>) : (
    <div style={{ marginTop: "50px", display :"flex", flexDirection:"column" ,alignItems:"center", width:'100%'}}>
      <img src="page1.png" alt="" width={200} />
      <h2>SpaceGut Reports</h2>
      <form style={{display :"flex", flexDirection:"column" ,alignItems:"center", width:'100%'}} onSubmit={handleSubmit}>
        {/* <label htmlFor="kitcode" style={{ display: "block", marginBottom: "10px" }}>
          Enter Kit Code:
        </label> */}
        <input
          type="text"
          id="kitcode"
          placeholder="Enter Kit Code:"//e.g : SGDEMO"
          value={kitcode}
          onChange={(e) => setKitCode(e.target.value)}
          style={{
            padding: "10px",
            fontSize: "16px",
            width: "200px",
            marginBottom: "20px",
            display: "block",
            borderRadius:"10px"
          }}
        />
        <button
        // onClick={()=>setGenerate(true)}
          type="submit"
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            backgroundColor: "#a1421d",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Generate Report
        </button>
      </form>
      
      {newerr && report ? <h4 style={{color:"#a1421d"}}>Some error occured please try again</h4> : null}
    </div>
  );
}




export default App;
